import type { MenuItem } from 'primereact/menuitem';
import { useLocation, useNavigate } from 'react-router-dom';
import { TabMenu } from 'primereact/tabmenu';
import { Outlet } from 'react-router';
import { useEffect, useMemo, useState } from 'react';

function LookAndFeel() {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);
  const location = useLocation();
  const menuModel = useMemo<MenuItem[]>(
    () => [
      {
        id: '',
        label: 'Colours',
        command() {
          navigate('');
        },
        data: { fullPath: '/app-customisation/look-and-feel' },
      },
      // {
      //   id: 'fonts',
      //   label: 'Fonts',
      //   command() {
      //     navigate('fonts');
      //   },
      //   data: { fullPath: '/app-customisation/look-and-feel/fonts' },
      // },
      {
        id: 'images',
        label: 'Images',
        command() {
          navigate('images');
        },
        data: { fullPath: '/app-customisation/look-and-feel/images' },
      },
      {
        id: 'fonts',
        label: 'Fonts',
        command() {
          navigate('fonts');
        },
        data: { fullPath: '/app-customisation/look-and-feel/fonts' },
      },
      {
        id: 'links',
        label: 'Links',
        command() {
          navigate('links');
        },
        data: { fullPath: '/app-customisation/look-and-feel/links' },
      },
      {
        id: 'emails',
        label: 'Emails',
        command() {
          navigate('emails');
        },
        data: { fullPath: '/app-customisation/look-and-feel/emails' },
      },
    ],
    [navigate],
  );

  useEffect(() => {
    setActiveIndex(
      menuModel.findIndex((item) => {
        return location.pathname === item.data.fullPath;
      }),
    );
  }, [location.pathname, menuModel]);
  return (
    <div className="flex flex-col gap-10">
      <TabMenu
        model={menuModel}
        className="!text-2xl"
        activeIndex={activeIndex}
      />
      <Outlet />
    </div>
  );
}

export default LookAndFeel;
